import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useSD() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/sd/")
    .then((res: SuccessFetch<{
      payload: {
        sd_id: number
        sd_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.sd_name, value: item.sd_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/sd/").then((res: SuccessFetch<{
      payload: {
        sd_id: number
        sd_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.sd_name,
          value: item.sd_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}